import { IssuerId } from "@goodfill/domain-properties";
import { calculateRandomColorFromSeed } from "@goodfill/color";

export function calculateIssuersColor(issuerId: IssuerId): string {
  return calculateRandomColorFromSeed(`${issuerId}`);
}
